var React = require('react');

function PageStroke (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fill":"#FFFFFF","d":"M265.875,0h-4.193l0,0H15C6.729,0,0,6.729,0,15v344.926c0,8.271,6.729,15,15,15h285c8.271,0,15-6.729,15-15\r\n\t\tV55.379v-2.061v-4.242L265.875,0z M267.682,10.243l11.482,11.483l25.593,25.593h-28.075c-2.404,0-4.664-0.936-6.364-2.636\r\n\t\tc-1.699-1.7-2.636-3.96-2.636-6.364V10.243z M309,359.926c0,4.963-4.037,9-9,9H15c-4.962,0-9-4.037-9-9V15c0-4.962,4.038-9,9-9\r\n\t\th246.682v32.318c0,4.007,1.561,7.774,4.394,10.607s6.601,4.394,10.606,4.393H309V359.926z"})));
}

PageStroke.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"315px","height":"374.926px","viewBox":"0 0 315 374.926","enableBackground":"new 0 0 315 374.926","xmlSpace":"preserve"};

module.exports = PageStroke;

PageStroke.default = PageStroke;
